import React, {forwardRef} from 'react'
import clsx from '../../../../helpers/clsx'
import {Spinner} from 'reactstrap'

export const LoadingSpinner = forwardRef(({className, ...rest}, ref) => {
    return (
        <div ref={ref} className={clsx('LoadingSpinner', className)} {...rest}>
            <Spinner style={{color: '#007bff'}}/>
        </div>
    )
})

export default LoadingSpinner
